import { LanguageService } from 'src/app/shared/services/language.service';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { from, Observable, throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { ILogin } from 'src/app/interfaces/ilogin';
import { UserService } from '../services/user.service';
import { AlertService } from './alert.service';
import { CryptoSharkService } from './crypto-shark.service';
// import { AlertService } from '../services/alert.service';

@Injectable({
  providedIn: 'root'
})
export class TokenInterceptorService implements HttpInterceptor {
  
  constructor(
    private userService: UserService, 
    private router: Router,/*private alertService: AlertService*/
    private cryptoService: CryptoSharkService, 
    private alertService: AlertService,
    private modalService: NgbModal,
    public languageService: LanguageService
    ) { }
  
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return from(this.handle(req, next)).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          // console.log(event);
        }
        return event;
      }),
      catchError((resp: any) => {
        if (resp.status == 403) {
          // this.alertService.show('!Ups!', resp.error.message);
          this.router.navigate(['login'], {
            queryParams: { returnUrl: this.router.url },
          });
          this.modalService.dismissAll();
          this.alertService.infoToast("Su sesión a expirado!")
          this.userService.signOutCurrentUser();
        }
        return throwError(resp);
      }));
  }

  async handle(req: HttpRequest<any>, next: HttpHandler): Promise<HttpEvent<any>> {
    const login: ILogin = JSON.parse(localStorage.getItem('ldt'));
    if (login) {
      req = req.clone({
        setHeaders: {
          'token': login.token,
          "lang":this.languageService.default_lang == "MX" ? 'ESP' : this.languageService.default_lang == "US" ? 'ENG' : 'ESP'
        }
      });
    }

    if (!req.headers.has('app')) {
      req = req.clone({
        setHeaders: {
          "app": this.cryptoService.encryptAes('mk5')
        }
      });
    }

    req = req.clone({
      setHeaders: {
        'type': 'WEB',
        "lang":this.languageService.default_lang == "MX" ? 'ESP' : this.languageService.default_lang == "US" ? 'ENG' : 'ESP'
      }
    });

    req = req.clone({
      setHeaders: {
        'language': this.languageService.default_lang == "MX" ? 'ES' : this.languageService.default_lang == "US" ? 'EN' : 'ES',
      },
    });

    req = req.clone({
      // headers: req.headers.set('Accept', 'application/json')
    });

    return next.handle(req).toPromise();
  }
}
